module.exports = __webpack_public_path__ + "img/shot3.e2f4c8c.png";